import { toast } from "react-toastify";
import axios from "axios";

export const getEnquiryList = (token, paginate = 10, page = 1, search = "", sort = "desc") => async (dispatch) => {
  try {
    dispatch({ type: "GET_ENQUIRYLIST_PENDING" });

    const response = await axios.get(
      `/api/supplier/supplier-enquiries`,
      {
        params: {
          paginate: paginate,
          page: page,
          search: search,
          sort: sort,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "GET_ENQUIRYLIST_FULFILLED", payload: response.data?.enquiries });
  } catch (error) {
    dispatch({ type: "GET_ENQUIRYLIST_REJECTED", payload: error.response });
  }
};

export const deleteEnquiryData = (token, enquiryId) => async (dispatch) => {
  try {
    dispatch({ type: "DELETE_ENQUIRY_PENDING" });

    const response = await axios.delete(`/api/supplier/delete-enquiry/${enquiryId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    dispatch({
      type: "DELETE_ENQUIRY_FULFILLED",
      payload: response.data,
    });
  } catch (error) {
    console.log(error);
    dispatch({
      type: "DELETE_ENQUIRY_REJECTED",
      payload: error.response,
    });
  }
};

export const addEnquiryNotes = (token, data) => async (dispatch) => {
  try {

    dispatch({ type: "ADD_ENQUIRY_NOTE_PENDING" });

    const response = await axios.post(`/api/supplier/create-note`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    dispatch({
      type: "ADD_ENQUIRY_NOTE_FULFILLED",
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: "ADD_ENQUIRY_NOTE_REJECTED",
      payload: error.response,
    });
  }
};
export const sendQuotation = (token, data) => async (dispatch) => {
  try {

    dispatch({ type: "SEND_QUOTATION_PENDING" });

    const response = await axios.post(`/api/supplier/sendQuotaionBySupplier`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    dispatch({
      type: "SEND_QUOTATION_FULFILLED",
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: "SEND_QUOTATION_REJECTED",
      payload: error.response,
    });
  }
};
